import * as Yup from 'yup';

export class UpdateVehicleTypeValidator {
  public get schema() {
    return Yup.object().shape({
      name: Yup.string().required('Informe o nome do tipo de veículo'),
      blockedAt: Yup.string()
        .nullable()
        .transform((value) => {
          if (value === '1') return new Date().toISOString();
          return null;
        }),
      fidsRingType: Yup.number()
        .typeError('Escolha o tipo do radar')
        .oneOf([1, 2], 'Escolha o tipo do radar')
        .required('Escolha o tipo do radar'),
    });
  }
}
